import {
    de,
    enGB,
    es,
    fr,
    hu,
    it,
    pl,
    ro,
    ru,
    tr,
    uk,
    vi,
} from 'date-fns/locale';

class DateLocale {
    // one entry per locale that kgr.languages makes selectable, otherwise dates fall back to German
    static localeMap = {
        de_DE: de,
        en_GB: enGB,
        fr_FR: fr,
        es_ES: es,
        ru_RU: ru,
        tr_TR: tr,
        uk_UA: uk,
        it_IT: it,
        pl_PL: pl,
        ro_RO: ro,
        hu_HU: hu,
        vi_VN: vi,
    };

    /**
     * Returns a date-fns locale object for a given translateTo string.
     * @param {string} translateTo - e.g. 'de_DE', 'en_US'
     * @param fallback - fallback locale if not found
     * @returns date-fns locale
     */
    static getLocale(translateTo, fallback = de) {
        return this.localeMap[translateTo] || fallback;
    }
}

export default DateLocale;
